import React from 'react';
import { Truck, MapPin } from 'lucide-react';
import { Button } from '../ui/button';
import MondialRelayPicker from '../MondialRelayPicker';
import { carrierLogo } from '../../services/carriers';
import { useT } from '../../services/i18n';

const CheckoutCarrierSection = ({ shipOptions, carrier, setCarrier, selectedShip, relayPoint, setRelayPoint, relayOpen, setRelayOpen, shippingInfo }) => {
  const { t } = useT();
  return (
    <div className="mt-6 border-t pt-4" data-testid="checkout-carriers">
      <h3 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2"><Truck size={16} className="text-orange-500" /> {t('checkout.carrier')}</h3>
      {shipOptions.options.length === 0 ? (
        <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2" data-testid="checkout-no-carrier">{t('checkout.errCountry')}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {shipOptions.options.map((o) => (
            <label key={o.carrier} data-testid={`carrier-option-${o.carrier.replace(/\s/g, '-')}`} className={`flex items-center gap-3 border rounded-lg px-3 py-2.5 cursor-pointer transition-colors ${carrier === o.carrier ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-gray-300'}`}>
              <input type="radio" name="carrier" checked={carrier === o.carrier} onChange={() => setCarrier(o.carrier)} className="accent-orange-500" />
              {carrierLogo(o.carrier) ? <img src={carrierLogo(o.carrier)} alt={o.carrier} className="h-7 w-14 object-contain shrink-0 no-placeholder" data-testid={`carrier-logo-${o.carrier.replace(/\s/g, '-')}`} /> : <Truck size={20} className="text-gray-400 shrink-0 w-14" />}
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-medium text-gray-900">{o.name}{o.relay ? ` · ${t('checkout.relay')}` : ''}</span>
                <span className="block text-xs text-gray-500">{o.delay}{o.tyre_free ? ` · ${t('checkout.tyreFree')}` : ''}{o.weight_tiered ? ` · ${t('checkout.weightTier', { w: o.weight_kg })}` : ''}</span>
              </span>
              <span className={`text-sm font-semibold ${o.price === 0 ? 'text-green-600' : 'text-gray-900'}`}>{o.price === 0 ? t('common.free') : `${o.price.toFixed(2)} €`}</span>
            </label>
          ))}
        </div>
      )}
      {selectedShip?.relay && (
        <div className="mt-3 rounded-lg border border-orange-200 bg-orange-50 px-3 py-2.5 flex flex-wrap items-center justify-between gap-2" data-testid="checkout-relay-block">
          <div className="text-sm text-gray-800 flex items-center gap-2"><MapPin size={16} className="text-orange-500" />
            {relayPoint ? <span data-testid="checkout-relay-selected"><strong>{relayPoint.name}</strong> — {relayPoint.address1}, {relayPoint.postal_code} {relayPoint.city}</span> : <span>{t('checkout.relayRequired')}</span>}
          </div>
          <Button type="button" size="sm" variant="outline" onClick={() => setRelayOpen(true)} data-testid="checkout-relay-pick" className="border-orange-400 text-orange-700 hover:bg-orange-100">{relayPoint ? t('checkout.relayChange') : t('checkout.relayPick')}</Button>
          <MondialRelayPicker open={relayOpen} onOpenChange={setRelayOpen} postalCode={shippingInfo.postalCode} country={shippingInfo.country} brand={shipOptions.relay_brand} onSelect={setRelayPoint} />
        </div>
      )}
    </div>
  );
};

export default CheckoutCarrierSection;
